import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import * as Highcharts from "highcharts";
import { HeaderService } from "../../header/header.service";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-lines-chart",
  templateUrl: "./line-chart.component.html",
  styleUrls: ["./line-chart.component.scss"],
})
export class LineChartComponent implements OnInit, OnChanges, OnDestroy {
  @Input() id;
  @Input() data;
  @Input() chartColors: any[];
  @Input() labels: any[];
  @Input() yAxisLabelType: any;
  @Input() showFillColor: true;
  @Input() chartLegendName: any[];
  @Input() tickInterval;
  @Input() type = 'line';;
  @Input() height;
  @Input() width;
  @Input() hideSeries: any[] = [];
  @Input() isKpiLineGraph: boolean;
  @Input() isPosition:boolean;
  @Input() yAxisLabelType1:any
@Input() labelFontSize = '12px';
  @Input()isKpiSalesLineGraph:boolean;
  @Input()isShowPercentageOnly:boolean;
  @Input() isSetpositionTooltip:boolean=false;
  private destroy$ = new Subject<void>();
  @Input() isDecimal:boolean = false;

  constructor(private headerService: HeaderService) {
    this.headerService.hideLine.pipe(takeUntil(this.destroy$)).subscribe((e) => {
      this.toggleSeries(e.showHideChartData, e.chartId);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.data && this.showFillColor) this.data[0].fillColor = "#CEDBFE";
    this.drawLineChart();
  }

  ngOnInit(): void {
    if (this.data && this.showFillColor) this.data[0].fillColor = "#CEDBFE";

    this.drawLineChart();
  }

  public drawLineChart() {
    let maxValue = this.calculateMaxValueFromData();
    const tickCount = this.calculateTickCount(maxValue);
    let interval = this.tickInterval;
    let yAxisType = this.yAxisLabelType;
    let yAxisType1 = this.yAxisLabelType1;
    let isFillColor = this.showFillColor;
    let labelFontSize = this.labelFontSize;
    let isKpiSalesLineGraph = this.isKpiSalesLineGraph;
    let isShowPercentageOnly = this.isShowPercentageOnly;
    let isSetpositionTooltip = this.isSetpositionTooltip;
    let isDecimal = this.isDecimal;
    const tooltipPosition = this;
    Highcharts.setOptions({
      colors: this.chartColors,
    });
    const options: any = {
      chart: {
        type: this.type,
        plotBorderWidth: null,
        plotShadow: false,
        height: this.height,
        spacingBottom: 0,
      },
      credits: {
        enabled: false,
      },
      title: {
        text: "",
        style: {
          fontSize: "24px",
        },
      },
      xAxis: {
        visible: true,
        gridLineWidth: this.isKpiLineGraph ? 1 : 0,
        grid: {
          tickBorderDash: [18, 4],
          display: true,
        },
        lineWidth: 1,
        border: {
          dash: [12, 14],
        },
        gridLines: {
          borderDash: [18, 14],
          color: "#348632",
        },
        categories: this.labels,
        title: {
          text: "",
        },
        labels: {
          style: {
            fontSize: isSetpositionTooltip ? "8px" : "12px",
            fontFamily: "Banana_R",
            color: "black",
            fontWeight: 400,
            lineHeight: 1.5,
          },
        },
      },
      yAxis: [
        {
          visible: true,
          startOnTick: true,
          gridLineColor: "#D3D3D3",
          gridLineDashStyle: this.isKpiLineGraph ? "" : "dash",
          grid: {
            tickBorderDash: [18, 4],
            display: true,
          },
          gridLineWidth: 1,
          min: 0,
          max: maxValue,
          pointLabels: {
            display: true,
          },
          tickPositioner: function () {
            const positions = [];
            for (let i = 0; i <= tickCount; i++) {
              positions.push(Math.round((maxValue / tickCount) * i));
            }
            return positions;
          },
          tickInterval: !this.isPosition
            ? Array.isArray(interval)
              ? interval[0]
              : interval
            : undefined,
          minRange: 2,
          title: {
            text: "",
          },
          opposite: false,
          labels: {
            style: {
              fontSize: "12px",
              color: "#888888",
              fontWeight: 400,
            },
            enabled: yAxisType === "hide" ? false : true,
            stepSize: 1,
            formatter: function () {
              if (this.value >= 1000) {
                const abbreviations = ['', 'K', 'M', 'B', 'T'];
                const index = Math.floor(Math.log(Math.abs(this.value)) / Math.log(1000));
                return (
                  (isKpiSalesLineGraph && yAxisType === "dollar" ? "$" : "") +
                  (Math.round((this.value / Math.pow(1000, index)) * 100) / 100).toFixed(1) +
                  (yAxisType === "percentage" ? "%" : (yAxisType === "showK" || isKpiSalesLineGraph) ? abbreviations[index] : '')
                );
              } else {
                return yAxisType === "percentage"
                  ? [this.value] + " %"
                  : yAxisType === "dollar"
                  ? "$" + [this.value]
                  : [this.value];
              }
            },
          },
        },
        {
          visible: true,
          title: {
            text: "",
          },
          opposite: true,
          labels: {
            style: {
              fontSize: "12px",
              color: "#888888",
              fontWeight: 400,
            },
            formatter: function () {
              if (this.value >= 1000) {
                const abbreviations = ['', 'K', 'M', 'B', 'T'];
                const index = Math.floor(Math.log(Math.abs(this.value)) / Math.log(1000));
                return (
                  (isKpiSalesLineGraph && yAxisType1 === "dollar" ? "$" : "") +
                  (Math.round((this.value / Math.pow(1000, index)) * 100) / 100).toFixed(1) +
                  (yAxisType1 === "percentage" ? "%" : yAxisType1 === "showK" ? abbreviations[index] : '')
                );
              } else {
                return yAxisType1 === "percentage"
                  ? [this.value] + " %"
                  : yAxisType1 === "dollar"
                  ? "$" + [this.value]
                  : [this.value];
              }
            },
          },
          tickInterval: !this.isPosition
            ? Array.isArray(interval)
              ? interval[1]
              : interval
            : undefined,
          tickPositions: this.isPosition
            ? Array.isArray(interval)
              ? interval[1]
              : interval
            : undefined,
          gridLineWidth: 0,
        },
      ],
      legend: {
        verticalAlign: "top",
      },

      tooltip: {
        crosshairs: true,
        shared: true,
        style: {
          fontSize: isSetpositionTooltip ? "9px" : "12px",
         },
         positioner: function (boxWidth, boxHeight, point) {
          return tooltipPosition.setTooltipPosition(
            boxWidth,
            boxHeight,
            point,
            this.chart
          );
        },
        formatter: function () {
          let tooltipContent = this.points[0].point.category + "<br/>";
          this.points.forEach((point, index) => {
            tooltipContent +=
              '<span style="color:' +
              point.color +
              '">\u25CF</span>  <b>' +
              point.series.name +
              "</b>: ";
          const decimalPlaces = isDecimal ? 2 : 0;
          const formattedValue = Highcharts.numberFormat(point.y, decimalPlaces, '.', ',');
            tooltipContent +=
              (yAxisType === "dollar" ? "$" : "") +
               formattedValue +
              (yAxisType === "percentage" ? "%" : "") +
              "<br/>";
          });
          return tooltipContent;
        },
      },
      plotOptions: {
        series: {
          pointWidth: 15,
          fillOpacity: isFillColor ? 0.1 : 0.0,
          marker: { enabled: false },
        },
        line: {
          dataLabels: {
            enabled: false,
          },
        },
      },
      series: this.data,
    };

    Highcharts.chart(this.id, options);
  }

  public setTooltipPosition( boxWidth, boxHeight,point, chart): { x: number; y: number } {
    let x = Math.max(point.plotX + chart.plotLeft, chart.plotLeft);
    let y = Math.max(point.plotY + chart.plotTop, chart.plotTop);
    if (x + boxWidth > chart.chartWidth) {
      x -= boxWidth;
    }
    y += y + boxHeight + 5 > chart.chartHeight ? -boxHeight - 5 : 5;
    return { x, y };
  }

  toggleSeries(series, chartId): void {
    let chart: any;
    Highcharts.charts.forEach((res: any) => {
      if (res && res.renderTo.id == chartId) {
        chart = res;
      }
    })
    if (chart?.series) chart?.series.forEach((res) => res.show());
    series.forEach((res) => {
      for (let i = 0; i < chart?.series.length; i++) {
        if (chart?.series[i].name == res) {
          chart?.series[i].hide();
          break;
        }
      }
    });
  }

  private calculateMaxValueFromData(): number {
    let maxValue = 0;
    if (this.data && this.data.length > 0) {
      this.data.forEach((series) => {
        if (series.data && Array.isArray(series.data)) {
          series.data.forEach((value) => {
            if (value > maxValue) {
              maxValue = value;
            }
          });
        }
      });
    }
    return maxValue;
  }

  private calculateTickCount(maxValue: number): number {
    if (maxValue <= 100) {
      return 4;
    } else if (maxValue <= 1000) {
      return 5;
    } else {
      return 6;
    }
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
